import axios from "axios";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";

function ClientProsModal({ onClose, data }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const user = JSON.parse(localStorage.getItem("user"));
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const onSubmit = async (data) => {
    setGlobalLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/companyinfo/add_existing_client_to_pipeline`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("response from exiting client api", response);
      if (response.status === 200) {
        toastr.success(response.data.message);
        onClose?.(1);
      } else {
        toastr.error(response.data.message);
      }
    } catch (error) {
      setGlobalLoading(false);
      console.log(error);
      toastr.error(error?.response?.data?.message);
    } finally {
      setGlobalLoading(false);
    }
  };

  useEffect(() => {
    console.log("data", data);
    setValue("company_id", data?.company_id);
    setValue("companyinfo_id", data?.companyinfo_id);
    setValue("poc", user?.id);
  }, [data]);

  return (
    <>
      <div className="modal fade show d-block custom-modal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border border-dark rounded">
            <div className="modal-header">
              <h5 className="modal-title">
                Add Prospective Search - {data?.company_name}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <div className="d-flex align-items-center">
                      <div className="d-flex">
                        <div>
                          <p className="text-truncate fs-12 mb-0">
                            Client Owner:
                            <span className="fw-bold fs-12 text-dark mb-1 ms-1">
                              {`${data?.bd_by}`}
                            </span>
                            <span className="text-muted fs-12 fw-medium ms-1">
                              ({data?.bd_designation})
                            </span>
                          </p>
                          <p className="text-muted fs-10 op-9 mt-1">
                            Industry :{" "}
                            <span className="text-dark">
                              {data?.industrymaster}
                            </span>{" "}
                            | Status :{" "}
                            <span className="text-dark">
                              {data?.client_status}
                            </span>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">
                        Possible Searches
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <textarea
                        {...register("possible_searches", { required: true })}
                        className={`form-control ${
                          errors.possible_searches ? "is-invalid" : ""
                        }`}
                        rows="3"
                        placeholder="eg. CFO - India business , Indepenedent Director - Audit Committee"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">
                        Assigned To
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={`${user?.firstname} ${user?.lastname}`}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-dark me-2">
                  Add Search
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onClose}
                >
                  Back
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClientProsModal;
